import axios from "axios";

export const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
export const API = `${BACKEND_URL}/api`;

export const api = axios.create({
  baseURL: API,
  withCredentials: true,
});

export const LOGO_URL =
  "https://customer-assets.emergentagent.com/job_quality-floors-3/artifacts/hfy4evpy_cc%20logo%20transparent.jpeg";
export const LOGO_URL_TRANSPARENT = `${API}/logo.png`;

export const OWNER_NAME = "Corwin Calloway";
export const OWNER_TITLE = "Owner";

export const IMAGES = {
  hero:
    "https://images.unsplash.com/photo-1682888818620-94875adf5bb9?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NTYxODd8MHwxfHNlYXJjaHwxfHxtb2Rlcm4lMjBraXRjaGVuJTIwdGlsZSUyMGJhY2tzcGxhc2h8ZW58MHx8fHwxNzgzNzc5MDMyfDA&ixlib=rb-4.1.0&q=85",
  kitchen:
    "https://images.unsplash.com/photo-1556912102-ea493a2a5b93?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NTYxODd8MHwxfHNlYXJjaHwzfHxtb2Rlcm4lMjBraXRjaGVuJTIwdGlsZSUyMGJhY2tzcGxhc2h8ZW58MHx8fHwxNzgzNzc5MDMyfDA&ixlib=rb-4.1.0&q=85",
  bathroom:
    "https://images.unsplash.com/photo-1696987007764-7f8b85dd3033?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjAzNTl8MHwxfHNlYXJjaHwxfHxsdXh1cnklMjBiYXRocm9vbSUyMHRpbGUlMjBzaG93ZXJ8ZW58MHx8fHwxNzgzNzc5MDMyfDA&ixlib=rb-4.1.0&q=85",
  living:
    "https://images.unsplash.com/photo-1661099548731-fc8f74fc9dd9?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjA2MjJ8MHwxfHNlYXJjaHwzfHxtb2Rlcm4lMjBsdXh1cnklMjBpbnRlcmlvciUyMHdvb2QlMjBmbG9vciUyMHN1bmxpZ2h0fGVufDB8fHx8MTc4Mzc3OTAzMnww&ixlib=rb-4.1.0&q=85",
  custom:
    "https://images.unsplash.com/photo-1522061541612-28ef361a3045?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NTYxOTJ8MHwxfHNlYXJjaHwzfHxjdXN0b20lMjBnZW9tZXRyaWMlMjB0aWxlJTIwZmxvb3J8ZW58MHx8fHwxNzgzNzc5MDMzfDA&ixlib=rb-4.1.0&q=85",
  repair:
    "https://images.unsplash.com/reserve/oIpwxeeSPy1cnwYpqJ1w_Dufer%20Collateral%20test.jpg?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjAzMzV8MHwxfHNlYXJjaHwxfHxmbG9vciUyMHJlcGFpciUyMGNyYWZ0c21hbiUyMHRvb2xzfGVufDB8fHx8MTc4Mzc3OTAzM3ww&ixlib=rb-4.1.0&q=85",
  about:
    "https://images.unsplash.com/photo-1581783898377-1c85bf937427?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjAzMzV8MHwxfHNlYXJjaHwyfHxmbG9vciUyMHJlcGFpciUyMGNyYWZ0c21hbiUyMHRvb2xzfGVufDB8fHx8MTc4Mzc3OTAzM3ww&ixlib=rb-4.1.0&q=85",
};

export const GALLERY_CATEGORIES = [
  { key: "kitchens", label: "Kitchens" },
  { key: "bathrooms", label: "Bathrooms" },
  { key: "living_spaces", label: "Living Spaces" },
  { key: "custom_tile", label: "Custom Tile" },
];

export const fileUrl = (path) => `${API}/files/${path}`;
